"use client";

import { usePathname } from "next/navigation";
import styles from "./MainContentWrapper.module.scss";

interface MainContentWrapperProps {
  children: React.ReactNode;
}

export default function MainContentWrapper({
  children,
}: MainContentWrapperProps) {
  const pathname = usePathname();
  const pathSegments = pathname?.split("/");

  const shouldShowPadding = (pathSegments?.length ?? 0) > 4;

  return (
    <main className={shouldShowPadding ? styles.mainContent : ""}>
      {children}
    </main>
  );
}
